module.exports = __webpack_public_path__ + "static/media/depositi.d814a19e.svg";